import { colors } from "utils";

export const backgroundColors = {
  PrimaryBlue150: colors.PrimaryBlue150,
  BlackOpacity: "rgba(0,0,0,0.3)",
  BlackOpacityDark: "rgba(0,0,0,0.6)",
};
